export default __webpack_public_path__ + "static/media/stress.03b2188d.png";